import { ethers } from "ethers";

import crossChainAbi from "@/connect/abi/crossChainAbi";

export default class CrossChainContracts extends ethers.Contract {
  constructor(_provider, account, contract) {
    super(contract, crossChainAbi, _provider.getSigner(account));
  }
}
